export function useCalcDocContentPaddingTop() {
  return 21;
}
